import { useState, useEffect } from 'react'
import i18n from '../../../i18n'
import { bruktbilfinansieringAPI } from '../../../services/api'
import type { CrossBankDealersResponse } from '../../../types/bruktbilfinansiering'
import type { BruktbilfinansieringFilters } from './useBruktbilfinansiering'

export function useDealersCrossBank(bankOrgNr: string, filters: BruktbilfinansieringFilters) {
  const [data, setData] = useState<CrossBankDealersResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    setError(null)
    // Pass classes when a buyer-type filter is active; both /dealers and
    // /dealers-cross-bank must use the same class filter so bankmix stays aligned.
    bruktbilfinansieringAPI.getDealersCrossBank(bankOrgNr, {
      start_date: filters.startDate,
      end_date: filters.endDate,
      dealer_postnummer: filters.dealerPostnummer ?? undefined,
      buyer_postnummer: filters.buyerPostnummer ?? undefined,
      varebil: filters.varebil,
      classes: filters.classes,
    })
      .then(res => setData(res.data))
      .catch(e => setError(e instanceof Error ? e.message : i18n.t('errors.unknown', { ns: 'bbf' })))
      .finally(() => setLoading(false))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankOrgNr, filters.startDate, filters.endDate, filters.dealerPostnummer, filters.buyerPostnummer, filters.varebil, JSON.stringify(filters.classes)])

  return { data, loading, error }
}
